import { SocketAsFetch } from '@leagueplatform/socket-as-fetch';
import { GET_RECENT_ACHIEVEMENTS_MESSAGE_TYPE } from '#constants/message-type.constants.ts';
import { GetRecentAchievementsResponse } from '#types/response.types.ts';

export const getRecentAchievements =
  (): Promise<GetRecentAchievementsResponse> =>
    SocketAsFetch.fetch({
      message_type: GET_RECENT_ACHIEVEMENTS_MESSAGE_TYPE,
    });
